import React from 'react';

const Form = props => {
  const { onHandleSubmit } = props;
  return (
    <form name="form" className="Form" onSubmit={onHandleSubmit}>
      <label htmlFor="title" className="Form__titleText">
        Title
        <br />
        <input type="text" name="title" className="Form__titleInput" required placeholder="Title" autoComplete="off" />
      </label>
      <label htmlFor="description" className="Form__descriptionText">
        Description
        <br />
        <input type="text" name="description" className="Form__descriptionInput" placeholder="Description" autoComplete="off" />
      </label>
      <label htmlFor="tags" className="Form__tagsText">
        Tags
        <br />
        <input type="text" name="tags" className="Form__tagsInput" placeholder="Tags (comma-separated)" autoComplete="off" />
      </label>
      <input type="submit" value="Add Todo" className="Form__button" />
    </form>
  );
};

export default Form;
